import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

/** The platform console. Only platform admins outside any organization reach it. */
export const Route = createFileRoute("/_authenticated/_administration/settings/plans-modules")({
  beforeLoad: ({ context }) => guardRoute(context.me, "plans-modules"),
  component: Outlet,
});
